
import { INVENTORYANDSALES_URL, TREASURY_AND_ACCOUNTING_URL } from "utils/constants";
import { ENDPOINTS, ENDPOINTSINVENTORYANDSALES, ENDPOINTSTREASURYANDACCOUNTING } from "utils/endpoints";
import { http } from "utils/http";

export const getCustomerInfo = (customerId) => http({
    baseURL:INVENTORYANDSALES_URL,
    url: ENDPOINTSINVENTORYANDSALES.Sales.BaseInformationApi.Customer.customerInfo,
    method: 'get',
    params: {
        customerId
    }
}).then((res) => {
    return res.data
}).catch((err) => {
    return Promise.reject(err);
});

export const getTadbirSyncGetAccDetailRemain = (detailCode) => http({
    baseURL:TREASURY_AND_ACCOUNTING_URL,
    url: ENDPOINTSTREASURYANDACCOUNTING.Accounting.tadbirSyncGetAccDetailRemain,
    method: 'get',
    params: {
        detailCode
    }
}).then((res) => {
    return res.data
}).catch((err) => {
    return Promise.reject(err);
});
